import {
  ApiDeleteMyWishlistFailedAction,
  ApiDeleteMyWishlistSucceededAction,
  apiDeleteMyWishlistFailedType,
  apiDeleteMyWishlistRequested,
  apiDeleteMyWishlistSucceededType
} from '@spa/lib/store/api/wishlists/deleteMyWishlistApi';
import {
  DeleteMyWishlistRequestedAction,
  deleteMyWishlistFailed,
  deleteMyWishlistSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import { put, select } from 'typed-redux-saga';
import { SessionStateContent } from '@spa/lib/store/session/SessionState';
import generateActionId from '@spa/lib/generateActionId';
import selectSessionContent from '@spa/lib/store/session/selectors/selectSessionContent';
import { setContent } from '@spa/lib/store/session/sessionSlice';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* deleteMyWishlistSaga({
  payload: { actionId: requestedActionId, id }
}: DeleteMyWishlistRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(apiDeleteMyWishlistRequested({ actionId, id, parentActionId: requestedActionId }));

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiDeleteMyWishlistSucceededType,
    typeof apiDeleteMyWishlistFailedType,
    ApiDeleteMyWishlistSucceededAction,
    ApiDeleteMyWishlistFailedAction
  >(actionId, apiDeleteMyWishlistSucceededType, apiDeleteMyWishlistFailedType);

  if (waitResult.type === 'succeeded') {
    yield* put(deleteMyWishlistSucceeded({ requestedActionId, id }));

    const session: SessionStateContent = yield* select(selectSessionContent);
    if (session.selectedWishlist === id) {
      const newSession: SessionStateContent = { ...session, selectedWishlist: null };
      yield* put(
        setContent({
          localChange: false,
          content: newSession
        })
      );
    }
  } else {
    yield* put(
      deleteMyWishlistFailed({
        error: waitResult.action.payload.error,
        id,
        requestedActionId
      })
    );
  }
}

export default deleteMyWishlistSaga;
